import { ThrowStmt } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { OptionalOutputDto, OptionalService, StoreResponseDto } from 'src/generated_client';

@Component({
  selector: 'app-optionals-management',
  templateUrl: './optionals-management.component.html',
  styleUrls: ['./optionals-management.component.css']
})
export class OptionalsManagementComponent implements OnInit {

  displayedColumns: string[] = ['name', 'option'];
  allOptionals: OptionalOutputDto [] = [];
  storeResponse : StoreResponseDto= {} as StoreResponseDto;

  constructor(
    private router: Router,
    private optionalService : OptionalService,
    private authService : AuthService,
    private snackBar: SnackBarService
  ) { }

  ngOnInit(): void {

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.storeResponse = this.authService.currentUserStore();

    this.optionalService.apiOptionalGetAllByStoreGet(this.storeResponse.cdStore).subscribe(x=>{
      this.allOptionals = x;
    })
  }

  editOptional(id: number) {
    this.router.navigate(['edit-optional', id]);
  }

  addOptional() {
    this.router.navigate(['add-optional']);
  }


  deleteOptional(id:number){
    this.optionalService.apiOptionalDeleteDelete(id).subscribe(response=>{
        this.router.navigate(['optionals-management']);
        this.snackBar.openSnackBar('Se eliminó correctamente.', 'Aceptar');
      },
        (err) => {
          this.snackBar.openSnackBar(err.error.error, 'Aceptar')
        }
    )
  }
}
